function listenForPrintButtonClick() {
  $('.btn-print').on('click', function () {
    window.print();
  });
}

function listenForExports() {
  $('body').on('click', '[data-export]', function () {
    var currentPathFull = window.location.pathname;
    var searchForm = $('form[action="' + currentPathFull + '"]');
    var fileExtension = $(this).data('export').split('.')[1];
    var exportTarget = currentPathFull + '.' + fileExtension;
    searchForm.attr('action', exportTarget);
    searchForm.trigger('submit');
  });
}

function listenForFileSelect() {
  $(document).on('change', '.btn-file :file', function () {
    var input = $(this);
    var numFiles = input.get(0).files ? input.get(0).files.length : 1;
    var label = input.val().replace(/\\/g, '/').replace(/.*\//, '');
    input.trigger('fileselect', [numFiles, label]);
  });
  $('.btn-file :file').on('fileselect', function (event, numFiles, label) {
    var input = $(this).parents('.input-group').find(':text');
    var log = numFiles > 1 ? numFiles + ' files selected' : label;

    if (input.length) {
      input.val(log);
    } else if (log) {
      alert(log);
    }
  });
}

var Exports = {
  listenForExports: listenForExports,
  listenForFileSelect: listenForFileSelect,
  listenForPrintButtonClick: listenForPrintButtonClick
};
export default Exports;